export default {
  title: {
    en: `
    Your queue is below. You can add, rearrange or remove as many products as you want. If you don't<br/>
    schedule your orders, you will automatically receive the Perfume of the Month.
  `,
  },
  subTitle: {
    en: 'Check this video if you still have problems.',
  },
}
